<template>
  <tr
    v-bind:key="result.id">
      <td>{{ result.id }}</td>
      <td>{{ result.name }}</td>
      <td>{{ result.status }}</td>
      <td class="long-text-column">{{ result.localityName }}</td>
      <td>{{ result.acres | acresFormat }}</td>
      <td>
        <router-link
          :to="{ name: 'projectProperty', params: {
          project_id: result.projectId,
          property_id: result.id }}"
          class="btn btn-secondary btn-sm">
          View
        </router-link>
      </td>
  </tr>
</template>
<script>
export default {
  name: 'PropertySearchResultRow',
  props: {
    result: {
      type: Object,
    },
  },
};
</script>
